import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';

const AlgoMarketType = () => {
  return (
    <OrderRow labelId="order.fields.MarketType">
      <span className="fs-12">Off-shore</span>
    </OrderRow>
  );
};

export default AlgoMarketType;
